var _path, _path2, _circle, _circle2, _circle3, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclein4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 489,
    viewBox: "0 0 488 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.729 41.0722C240.701 39.1093 242.269 37.4919 244.233 37.4971C246.196 37.5023 247.755 39.1281 247.717 41.0909L247.266 63.9035C247.233 65.5888 245.84 66.9254 244.154 66.9209C242.468 66.9164 241.082 65.5724 241.058 63.8869L240.729 41.0722Z",
    fill: "#889BD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8003 243.7C35.8003 358.575 128.925 451.7 243.8 451.7C358.676 451.7 451.8 358.575 451.8 243.7C451.8 128.825 358.676 35.7002 243.8 35.7002C128.925 35.7002 35.8003 128.825 35.8003 243.7ZM420.6 243.7C420.6 341.344 341.444 420.5 243.8 420.5C146.156 420.5 67.0003 341.344 67.0003 243.7C67.0003 146.056 146.156 66.9002 243.8 66.9002C341.444 66.9002 420.6 146.056 420.6 243.7Z",
    fill: "#3B3D4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "matrix(-1 0 0 1 91.3545 323)",
    fill: "#889BD3",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "matrix(-1 0 0 1 426.354 323)",
    fill: "#889BD3",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "matrix(-1 0 0 1 259.354 35.7002)",
    fill: "#889BD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.625 40.0722C246.654 38.1093 245.085 36.4919 243.122 36.4971C241.159 36.5023 239.599 38.1281 239.638 40.0909L240.088 62.9035C240.122 64.5888 241.515 65.9254 243.2 65.9209C244.886 65.9164 246.272 64.5724 246.297 62.8869L246.625 40.0722Z",
    fill: "#889BD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4959 244.323C35.4959 359.298 128.702 452.503 243.677 452.503C358.652 452.503 451.857 359.298 451.857 244.323C451.857 129.348 358.652 36.1418 243.677 36.1418C128.702 36.1418 35.4959 129.348 35.4959 244.323ZM420.673 244.323C420.673 342.075 341.429 421.319 243.677 421.319C145.925 421.319 66.6807 342.075 66.6807 244.323C66.6807 146.57 145.925 67.3266 243.677 67.3266C341.429 67.3266 420.673 146.57 420.673 244.323Z",
    fill: "#889BD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclein4);
export default __webpack_public_path__ + "static/media/circlein4.8ee6a4f800379ecf3c42f4742e2f6a0f.svg";
export { ForwardRef as ReactComponent };